import { Component, OnInit } from '@angular/core';
import {
  AdminService,
  AppAuthServiceService,
  BroadcastUtilsService,
  SpinnerService,
  UserPreferencesService,
} from '@core';
import { TranslateService } from '@ngx-translate/core';
import { CatalogItem } from '@shared';
import { finalize, map, Observable, of } from 'rxjs';

@Component({
    selector: 'ups-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  public isIframe = false;
  public languages: CatalogItem[] = [];
  public message: Observable<{ body: string } | null> = of();

  private language = 'en';

  constructor(
    private translate: TranslateService,
    private appAuthService: AppAuthServiceService,
    private adminService: AdminService,
    private spinnerService: SpinnerService,
    private userPreferences: UserPreferencesService,
    private broadcastUtilsService: BroadcastUtilsService
  ) {}

  ngOnInit(): void {
    this.translate.setDefaultLang(this.language);
    this.isIframe = window !== window.parent && !window.opener;
    this.runLoggedInSetup();
    this.broadcastUtilsService.broadcastUpdate$.subscribe(() => this.loadUserLanguage());
  }

  private runLoggedInSetup(): void {
    this.appAuthService.isReady.subscribe(() => {
      if (this.appAuthService.isLoggedIn.getValue()) {
        this.checkSystemStatus();
        this.loadUserLanguage();
      }
    });
  }

  private checkSystemStatus(): void {
    this.spinnerService.show();
    this.adminService
      .checkSystemStatus()
      .pipe(finalize(() => this.spinnerService.hide()))
      .subscribe();
  }

  private loadUserLanguage() {
    const accountId = this.appAuthService.account.homeAccountId || '';
    this.userPreferences
      .getUserPreferences(accountId)
      .pipe(
        map((response) => {
          if (!response.error) {
            const { language } = response;
            this.language = language;
          }
          this.translate.use(this.language);
        })
      )
      .subscribe(() => this.broadcastCheckLatestAndListen());
  }

  public broadcastCheckLatestAndListen(): void {
    this.message = this.broadcastUtilsService.listenForBroadcast(this.language);
  }
}
